import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';

import { removeAccessToken } from '@utils';
import { profileReset } from '@store/userProfileSlice';
import { appLogout } from '@store/appStateSlice';
import { documentsReset } from '@store/documentsSlice/documentsSlice';
import { clearActiveVehicle } from '@utils/vehicle';
import { useAnalytics } from '@utils/analytics';

const Logout = () => {
  const dispatch = useDispatch();

  const { trackProcess } = useAnalytics();
  trackProcess('logout', 'complete');

  clearActiveVehicle();
  removeAccessToken();
  dispatch(appLogout());
  dispatch(profileReset());
  dispatch(documentsReset());

  return <Fragment />;
};

export default Logout;
